import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import {
  getSessionsV2,
  getSessionsAggregateV2,
  getSessionDetailsV2,
  createOrUpdateCaptarThreshold,
  getCaptarThreshold,
} from '../services/HemsV2Service';

export const useHemsV2GetSessionsV2 = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(getSessionsV2, 'requestBody', 'data'),
      'data',
      'fromDate',
      'toDate',
      'offset',
      'limit',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['fromDate', 'toDate', 'offset', 'limit'] },
    ],
  },
);

export const useHemsV2GetSessionsAggregateV2 = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(getSessionsAggregateV2, 'requestBody', 'data'),
      'data',
      'granularity',
      'fromDate',
      'toDate',
      'offset',
      'limit',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['granularity', 'fromDate', 'toDate', 'offset', 'limit'] },
    ],
  },
);

export const useHemsV2GetSessionDetailsV2 = createDCHook(
  'getSessionDetailsV2',
  collapseDataFromCall(getSessionDetailsV2),
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: true },
);

export const useHemsV2CreateOrUpdateCaptarThreshold = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(createOrUpdateCaptarThreshold, 'requestBody', 'data'),
      'data',
      'captarThreshold',
      'captarBuffer',
      'enabled',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['captarThreshold', 'captarBuffer', 'enabled'] },
    ],
  },
);

export const useHemsV2GetCaptarThreshold = createDCHook(
  'getCaptarThreshold',
  collapseDataFromCall(getCaptarThreshold),
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: true },
);
